<template>
  <div v-if="activities" >
    <header class="page-sub-heading">
      <h1 class="ut-font-bold">Database builder</h1>
      <ul class="date-filter">
        <li v-for="df in dateFilters" :key="df.value" :class="{'active': activeDateFilter == df.value}" @click="setActive(df)">{{df.label}}</li>
      </ul>
    </header>
    <p class="ut-text-base ut-mb-4">Helping you build more addresses and customer selling profiles. Meet more locals, win more listings</p>
    <div class="ut-flex cards-summary md: ut-justify-between ut-items-start">
        <prospect-activity-card
            :value="totalPliteCompletion"
            :title="'Customers enagaged on your behalf'"/>
        <prospect-activity-card
            :value="totalPliteCompletionByOwner"
            :title="'Addresses & selling profiles added'"/>
        <prospect-activity-card
            :value="totalProspects"
            :title="'Prospects generated'"/>
        <prospect-activity-card
            :value="nextBatchSize"
            :title="'Next customers to be prospected'"
            :styleClass="'oa-green-bg-color'" />
    </div>
    <div>
      <header class="page-sub-heading ut-flex-wrap">
        <h1>Customers by selling timeframe</h1>
        <div class="ut-my-2 markers-icon md:ut-mr-0">
          <p class="ut-text-xs ut-flex ut-content-start ut-items-center ut-text-left ut-mr-2">
            <img class="ut-m-1" width="17" src="@/assets/images/map-marker-green.svg" alt="Map marker icon"> <span class="ut-m-0">1-6 months</span>
            <img class="ut-m-1" width="17" src="@/assets/images/map-marker-teal.svg" alt="Map marker icon"> <span class="ut-m-0">6-12 months</span>
            <img class="ut-m-1" width="17" src="@/assets/images/map-marker-dark-green.svg" alt="Map marker icon"> <span class="ut-m-0">12+ months</span>
          </p>
        </div>
      </header>
      
      <div>
        <google-map class="prospecting-property-address-map"
          name="prospecting-property-address"
          :zoom="14"
          :mapCenterLat="agencyGeoLocation.latitude"
          :mapCenterLong="agencyGeoLocation.longitude"
          :enableMarkers="true"
          :enableMapControls="true"
          :enableInfoWindow="true"
          :enableMapBounds="false"
          :markersInfo="getMarkers" />
      </div>
    </div>
    <div class="ut-mb-8">
      <header class="page-sub-heading">
        <h1>Recent interactions</h1>
      </header>
      <div class="md:ut-justify-between ut-items-start">
        <prospecting-activity-card-details listIcon="icon-house" :textContent="textContent(a)" :activityDate="formatDate(a.activityDate, 'D MMM, YYYY H:mm')" :showExtraInfo="showExtraInfo(a)" :extraInfo="extraInfo(a)" v-for="(a, index) in recentInteactions" :key="index" />
        <load-more
          v-if="showLoadMore"
          @click.native="fetchMoreConversation()"
          :active="isLoading"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import ProspectActivityCard from '@/components/Prospecting/ProspectingDashboard/ProspectActivityCard.vue';
import ProspectingActivityCardDetails from '@/components/Prospecting/ProspectingDashboard/ProspectingActivityCardDetails.vue';
import { ProspectActivityActionTypeId, ProspectPropertyRelationshipId, ProspectSellingTimeframeId } from '@/Mapper/ProspectActivityActionType';
import ProspectStageType from '@/Mapper/ProspectStageType';
import LoadMore from '@/components/loading/LoadMore.vue';
import GoogleMap from '@/components/GoogleMap.vue';

export default {
  name: 'ProspectingDbbuilder',
  components: {
    ProspectActivityCard,
    ProspectingActivityCardDetails,
    LoadMore,
    GoogleMap,
  },
  props: {
    activities: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      gacategory: 'Prospecting Tool Agent portal',
      dateFilters: [
        { value: 1, label: '1M' },
        { value: 3, label: '3M' },
        { value: 0, label: 'ALL' },
      ],
      activeDateFilter: 0,
      pageSize: 10,
      pageNum: 1,
      isLoading: false,
      hideLoadMore: false,
      filteredResults: [],
    };
  },
  computed: {
    ...mapState({
      agent: state => state.agentStore.agent,
      userProspectorStatus: state => state.userStore.userProspectorStatus,
    }),
    showLoadMore() {
      return !this.hideLoadMore
        && this.pageSize * this.pageNum < this.filteredResults.length;
    },
    nextBatchSize() {
      return (this.userProspectorStatus.prospectingStatus.pLiteBatchSize || 0).toString();
    },
    agencyGeoLocation() {
      return this.userProspectorStatus.agencySuburb;
    },
    totalPliteCompletion() {
      if (this.activeDateFilter == 0) {
        return this.activities.totalPliteCompletions.toString();
      }
      const uniqueResults = this.$helpers.arrayGroupBy(this.activities.Activities, r => r.contactKey);
      const results = uniqueResults.filter(a => this.activityInDateRange(a.activityDate));
      return results.length.toString();
    },
    totalPliteCompletionByOwner() {
      if (this.activeDateFilter == 0) {
        return this.activities.totalPliteCompletionsByOwner.toString();
      }
      const results = this.getTotalPliteCompletionByOwner();
      return results.length.toString();
    },
    totalProspects() {
      if (this.activeDateFilter == 0) {
        return this.activities.totalProspects.toString();
      }
      return this.getProspects().length.toString();
    },
    recentInteactions() {
      return this.getRecentInteractions();
    },
    getMarkers() {
      const results = this.getTotalPliteCompletionByOwner();
      console.log(results);
      const markers = results
        .filter(r => r.contactPropertyAddress.lat && r.contactPropertyAddress.lng)
        .map(r => this.prepareMarker(r));
      console.log(markers);
      return markers;
    },
  },
  created() {},
  methods: {
    ...mapActions('prospectsStore', [
      'loadAgentActivities',
    ]),
    formatDate(date, format) {
      return this.$helpers.convertFromUTC(date, format);
    },
    setActive(dateFilter) {
      this.activeDateFilter = dateFilter.value;

    },
    activityInDateRange(activityDate) {
      if (!activityDate) { return false; }
      // format listed date
      activityDate = this.$helpers.convertFromUTC(activityDate);
      return this.activeDateFilter == 0 ? true : this.$helpers.isSameOrAfter(activityDate, this.$helpers.getPreviousDate(new Date(), this.activeDateFilter, 'months'), 'day');
    },
    getTotalPliteCompletionByOwner() {
      const filteredResults = this.activities.Activities.filter(
        a => a.metaData
          && a.metaData.propertyRelationship
          && [ProspectPropertyRelationshipId.ownerOccupier, ProspectPropertyRelationshipId.ownerInvestor].indexOf(a.metaData.propertyRelationship.propertyRelationshipId) > -1,
      );
      const uniqueResults = this.$helpers.arrayGroupBy(filteredResults, r => r.contactKey);
      const results = uniqueResults.filter(a => this.activityInDateRange(a.activityDate));
      return results;
    },
    getProspects() {
      // get all prospects activity
      const results = this.activities.Activities.filter(a => a.prospectStageTypeId == ProspectStageType.new);
      // filter unique prospects by prospect key
      const uniqueResults = this.$helpers.arrayGroupBy(results, r => r.prospectKey);
      console.log(uniqueResults.filter(a => this.activityInDateRange(a.activityDate)));
      return uniqueResults.filter(a => this.activityInDateRange(a.activityDate));
    },
    getRecentInteractions() {
      // get unique Plite activities completed by Owner(where activity date falls into date range filter)
      const uniqueResults = this.getTotalPliteCompletionByOwner();
      console.log(uniqueResults);
      this.filteredResults = uniqueResults;
      return uniqueResults.slice(0, this.pageNum * this.pageSize);
    },
    mapSellingTimeframe(activity) {
      if (activity.metaData.sellingTimeframe) {
        switch (activity.metaData.sellingTimeframe.sellingTimeframeId) {
          case ProspectSellingTimeframeId.within3Months:
          case ProspectSellingTimeframeId['3to6Months']:
          case ProspectSellingTimeframeId['6to12Months']:
          case ProspectSellingTimeframeId['12to24Months']:
            return `Selling in ${activity.metaData.sellingTimeframe.type}`;
          case ProspectSellingTimeframeId.immediately:
            return `Selling ${activity.metaData.sellingTimeframe.type}`;
          default:
            return activity.metaData.sellingTimeframe.type;
        }
      }
      return 'N/A';
    },
    textContent(activity, type) {
      // Contact full name - claimed ownership of address completed p-lite with as owner  and 1 other properties
      return `${this.$helpers.emptyPlaceholderWhenNoData(activity.contactFirstName)} ${this.$helpers.emptyPlaceholderWhenNoData(activity.contactLastName)} - claimed ownership of <b>${activity.metaData.address}</b> 
      ${this.checkOtherProperty(activity)} <br>Current stats - ${this.mapSellingTimeframe(activity)}`;
    },
    checkOtherProperty(activity) {
      let returnText = '';
      if (activity.contactKey) {
        // check If the user has completed p-lite multiple times as an owner add ‘and X other properties’
        const matchResults = this.activities.Activities.filter(
          a => a.contactKey == activity.contactKey
              && (
                a.metaData && a.metaData.propertyRelationship
                && [ProspectPropertyRelationshipId.ownerOccupier, ProspectPropertyRelationshipId.ownerInvestor].indexOf(a.metaData.propertyRelationship.propertyRelationshipId) > -1
                && a.metaData.address != activity.metaData.address),
        );
        if (matchResults.length > 1) {
          returnText = ` and ${matchResults.length - 1} other properties`;
        }
      }
      return returnText;
    },
    showExtraInfo(activity) {
      return true;
    },
    extraInfo(activity) {
      return this.showExtraInfo(activity) ? 'Address added by OpenAgent' : null;
    },
    fetchMoreConversation() {
      this.pageNum++;
    },
    prepareMarker(activity) {
      const iconUrl = this.getIconUrl(activity);
      if (activity.contactPropertyAddress.lat && activity.contactPropertyAddress.lng) {
        const name = `${this.$helpers.emptyPlaceholderWhenNoData(activity.contactFirstName)} ${this.$helpers.emptyPlaceholderWhenNoData(activity.contactLastName)}`;

        return {
          latitude: activity.contactPropertyAddress.lat,
          longitude: activity.contactPropertyAddress.lng,
          icon: iconUrl,
          infoWindowContent: `<div>
            <p class="ut-text-sm ut-text-dark-green-900">${name}</br><strong class="ut-text-neutral-900">${activity.metaData.address}</strong></p>
            <p class="ut-text-xs ut-text-dark-green-400 ut-flex ut-content-start ut-items-center ut-text-left"><img class="ut-m-0 ut-mr-1 ut--ml-1" width="17" src="${iconUrl}" alt="Map marker icon"> <span class="ut-m-0">Address added by OpenAgent</span></p></div>`,
        };
      }

      return null;
    },
    getIconUrl(activity) {
      if (activity.metaData.sellingTimeframe) {
        switch (activity.metaData.sellingTimeframe.sellingTimeframeId) {
          case ProspectSellingTimeframeId.immediately:
          case ProspectSellingTimeframeId.within3Months:
          case ProspectSellingTimeframeId['3to6Months']:
            return require('@/assets/images/map-marker-green.svg');

          case ProspectSellingTimeframeId['6to12Months']:
            return require('@/assets/images/map-marker-teal.svg');

          case ProspectSellingTimeframeId['12to24Months']:
            return require('@/assets/images/map-marker-dark-green.svg');

          default:
            return require('@/assets/images/map-marker-green.svg');
        }
      }
      return require('@/assets/images/map-marker-green.svg');
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.markers-icon {
  max-width: 280px;
}

.prospecting-property-address-map {
  height: 400px;
}

.cards-summary {
  margin: 0 -10px;
  @media (max-width: 768px) {
    flex-wrap: wrap;
  }
}

.page-sub-heading {
  @apply ut-flex ut-pb-6 ut-pt-12;

  @screen md {
    @apply ut-pb-6;
  }

  h1 {
    @apply ut-ml-0;
    font-size: 20px;
    letter-spacing: -0.4px;
    line-height: 36px;
    color: #1B1B1B;
  }
}
.date-filter {
  @apply ut-mr-2 ut-ml-auto ut-flex;
  li {
    @apply ut-ml-4;
    color: #ABAAA8;
    font-size: 11px;
    text-decoration: none;
  }
  li:hover {
    cursor: pointer;
  }
  li.active {
    @apply ut-font-bold;
    color: #22B35A;
    text-decoration: underline;
  }
}

.right-arrow-shape {
  box-sizing: border-box;
  height: 5px;
  width: 5px;
  border-top: 1px solid #25BA68;
  border-right: 1px solid #25BA68;
  transform: rotate(45deg);
  float: right;
}

.highlight-list {
  li {
    @apply ut-flex ut-justify-between ut-items-start;
    .count {
      @apply ut-text-xl ut-font-bold ut-text-neutral-001 ut-m-0;
      height: auto;
      width: 60px;
      padding: 14px;
      text-align: center;
    }
    .green-highlight {
      background: linear-gradient(180deg, #3AAA7C 0%, #25BA68 100%);
    }
    .medium-highlight {
      background: linear-gradient(180deg, #63B9B3 0%, #33837C 100%);
    }
    .dark-highlight {
      background: linear-gradient(180deg, #00605A 0%, #00322E 100%);
    }
    .content-text {
      box-sizing: border-box;
      border-top: 1px solid rgba(151, 151, 151, 0.2);
      height: auto;
      @apply ut-text-xs ut-w-full ut-m-0 ut-px-4;

      p {
        @apply ut-text-sm;
      }
      i {
        float: right;
      }
    }
  }
  li:last-child {
    .content-text {
      box-sizing: border-box;
      border-top: 1px solid rgba(151, 151, 151, 0.2);
      border-bottom: 1px solid rgba(151, 151, 151, 0.2);
    }
  }
}
</style>
